import type { FC } from "react";
import classes from "./Categories.module.scss";
import { Gamepad, GamepadProps } from "../../shared/components/Gamepad/Gamepad";
import { Characteristic } from "../../shared/components/Characteristic/Characteristic";

export interface GamepadType {
	id?: number;
	title: string;
	image: string;
	text: string;
}

export interface CharacteristicType {
	id: number;
	text_1: string;
	text_2: string;
	text_3: string;
	text_4: string;
	title: string;
}

export const Categories: FC = () => {
	const characteristic: CharacteristicType[] = [
		{
			id: 0,
			title: "Characteristic",
			text_1: "Characteristic",
			text_2: "Characteristic",
			text_3: "Characteristic",
			text_4: "Characteristic",
		},

		{
			id: 1,
			title: "Gamepad",
			text_1: "Long details of the first gamepad",
			text_2: "Details 1",
			text_3: "Details 1",
			text_4: "Long details of the first gamepad",
		},

		{
			id: 2,
			title: "Gamepad",
			text_1: "Long details of the second gamepad",
			text_2: "Details 2",
			text_3: "Details 2",
			text_4: "Long details of the second gamepad",
		},

		{
			id: 3,
			title: "Gamepad",
			text_1: "Long details of the third gamepad",
			text_2: "Details 3",
			text_3: "Details 3",
			text_4: "Long details of the third gamepad",
		},

		{
			id: 4,
			title: "Gamepad",
			text_1: "Long details of the fourth gamepad",
			text_2: "Details 4",
			text_3: "Details 4",
			text_4: "Long details of the fourth gamepad",
		},
	];

	const gamepad: GamepadType[] = [
		{
			id: 1,
			title: "Name",
			text: "300 RG (week)",
			image: "images/gamepad-1.png",
		},

		{
			id: 2,
			title: "Name",
			text: "300 RG (week)",
			image: "images/gamepad-2.png",
		},

		{
			id: 3,
			title: "Name",
			text: "300 RG (week)",
			image: "images/gamepad-3.png",
		},

		{
			id: 4,
			title: "Name",
			text: "300 RG (week)",
			image: "images/gamepad-4.png",
		},
	];

	return (
		<div className={classes.wrapper}>
			<div className={classes.part}>
				<h2 className={classes.title}>Joystick Categories</h2>
				<span className={classes.description}>
					We offer a selection of joysticks to cater to every kind of gamer
				</span>
				<span className={classes.get}>
					Here's a rundown of our four categories
				</span>
			</div>

			<div className={classes.content}>
				<div className={classes.categories}>
					{gamepad.map(({ id, title, text, image }) => (
						<Gamepad
							className={classes.gamepad}
							key={id}
							title={title}
							image={image}
						>
							{text}
						</Gamepad>
					))}
				</div>

				<div className={classes.characteristics}>
					{characteristic.map(
						({ id, title, text_1, text_2, text_3, text_4 }) => (
							<Characteristic
								className={classes.characteristic}
								key={id}
								text_1={text_1}
								text_2={text_2}
								text_3={text_3}
								text_4={text_4}
							>
								{title} <span className={classes.number}>{id}</span>
							</Characteristic>
						)
					)}
				</div>
			</div>
		</div>
	);
};
